import React from 'react';
import PropTypes from 'prop-types';
import Bookings from '../../../../components/Bookings';
import { BookingsListWrapper } from './styles';

const BookingsList = ({ bookingsList }) => (
  <BookingsListWrapper>
    {bookingsList.map((b) => (
      <Bookings key={b.id} {...b} />
    ))}
  </BookingsListWrapper>
);

BookingsList.propTypes = {
  bookingsList: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default BookingsList;
